import React from 'react'
import { useMediaQuery } from 'react-responsive';

const brands = [
    { src: "/assets/images/kwikwoocomm/img1.png", alt: "NaturalTein" },
    { src: "/assets/images/kwikwoocomm/img2.png", alt: "Star & Daisy " },
    { src: "/assets/images/kwikwoocomm/img3.png", alt: "Sam & Marshall" },
    { src: "/assets/images/kwikwoocomm/img4.png", alt: "One Science" },
    { src: "/assets/images/kwikwoocomm/img5.png", alt: "Frag Stalk" },
    { src: "/assets/images/kwikwoocomm/img6.png", alt: "Nikshan" },
    { src: "/assets/images/kwikwoocomm/img7.png", alt: "Bombay Trooper" },
    { src: "/assets/images/kwikwoocomm/img8.png", alt: "Stare Labs" },
    { src: "/assets/images/kwikwoocomm/img9.png", alt: "Roger Moters" },
    { src: "/assets/images/kwikwoocomm/img10.png", alt: "Fitness Stack" },
    { src: "/assets/images/kwikwoocomm/img11.png", alt: "Knit Root" },
    { src: "/assets/images/kwikwoocomm/img12.png", alt: "BIONE" },
    { src: "/assets/images/kwikwoocomm/img13.png", alt: "The Height Veda " },
    { src: "/assets/images/kwikwoocomm/img14.png", alt: "E2Z Store" },
    { src: "/assets/images/kwikwoocomm/img15.png", alt: "Splash Fragrance" },
    { src: "/assets/images/kwikwoocomm/img16.png", alt: "My Book Factory" },
    { src: "/assets/images/kwikwoocomm/img17.png", alt: "drkstore" }
];
const SectionTwo = () => {




    const isMobile = useMediaQuery({ maxWidth: 768 });


    return (
        <div>


            {isMobile ? (
                <div className="mobile-slider-Woo">
                    <p className="slider-text-Woo">Powering 15,000+ Indian D2C Brands</p>
                    <div className="slider-row-Woo left-to-right">
                        {[...brands.slice(0, 6), ...brands.slice(0, 6),...brands.slice(0, 6)].map((brand, index) => (
                            <img key={`r1-${index}`} src={brand.src} alt={brand.alt} className="slider-img-Woo" />
                        ))}
                    </div>
                    <div className="slider-row-Woo right-to-left">
                        {[...brands.slice(6, 12), ...brands.slice(6, 12)].map((brand, index) => (
                            <img key={`r2-${index}`} src={brand.src} alt={brand.alt} className="slider-img-Woo" />
                        ))}
                    </div>
                    <div className="slider-row-Woo left-to-right">
                        {[...brands.slice(12), ...brands.slice(12),...brands.slice(12)].map((brand, index) => (
                            <img key={`r3-${index}`} src={brand.src} alt={brand.alt} className="slider-img-Woo" />
                        ))}
                    </div>
                </div>
            ) : (
                <div className="banner-slider-Woo">
                    <p className="slider-text-Woo">Powering 15,000+ Indian D2C Brands</p>
                    <div className="slider-container-Woo">
                        <div className="slider-track-Woo">
                            {[...brands, ...brands].map((brand, index) => (
                                <img key={index} src={brand.src} alt={brand.alt} className="slider-img-Woo" />
                            ))}
                        </div>
                    </div>
                </div>
            )
            }


        </div>
    )
}

export default SectionTwo
